import { teamsApiV1 } from "../../../api";

export const removeMembersFromCareTeam = async (memberId: number, userId: number) => {
  const response = await teamsApiV1.deleteCareTeamMember(userId, {
    member_id: memberId,
    patient_id: userId,
  });
  return response.data;
};
